import classNames from 'classnames'
import { CONFIG } from 'shared/constants'
import css from './Header.styles.scss'

interface HeaderProps {
  eligibleForMultiUse?: boolean
}

export const Header = ({ eligibleForMultiUse }: HeaderProps) => {
  const preEligibilityAndSingleUseDiscountHeader = (
    <>
      Enjoy ${CONFIG.store.registryDiscountPctDisplay} off* with <br /> your
      registry discount
    </>
  )

  if (eligibleForMultiUse) {
    return (
      <>
        <div
          className={classNames(css.Header__container, [
            css[`Header__container--desktop`],
          ])}
        >
          Take {CONFIG.store.registryDiscountPctDisplay} off* everything with
          <br /> your registry discount
        </div>
        <div
          className={classNames(css.Header__container, [
            css[`Header__container--mobile`],
          ])}
        >
          {preEligibilityAndSingleUseDiscountHeader}
        </div>
      </>
    )
  }
  return (
    <div className={classNames(css.Header__container)}>
      {preEligibilityAndSingleUseDiscountHeader}
    </div>
  )
}
